import { AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";

/** items: [{name, conflicts:[{message}]}] */
export default function ConflictDialog({ open, onOpenChange, items = [], onAssignAvailable, availableCount = 0 }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#1a0b0b] border-red-600 max-w-lg" data-testid="conflict-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-300 text-lg font-heading">
            <AlertTriangle className="h-6 w-6" /> ⚠ CONFLITTO DI PIANIFICAZIONE
          </DialogTitle>
          <DialogDescription className="text-red-200/80">
            Il salvataggio è stato bloccato. I seguenti elementi non possono essere assegnati:
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-2 max-h-[50vh] overflow-y-auto scrollbar-thin">
          {items.map((it) => (
            <li key={`${it.resource_type || "r"}-${it.resource_id ?? it.name}`} className="rounded-lg border border-red-700/70 bg-red-950/50 p-3" data-testid={`conflict-item-${it.resource_type || "r"}-${it.resource_id ?? "x"}`}>
              <div className="font-semibold text-red-100">🔴 {it.name}</div>
              {it.conflicts.map((c) => <div key={c.message} className="text-sm text-red-200 mt-1">{c.message}</div>)}
            </li>
          ))}
        </ul>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="conflict-close-btn">Chiudi</Button>
          {onAssignAvailable && availableCount > 0 && (
            <Button onClick={onAssignAvailable} data-testid="conflict-assign-available-btn">Assegna solo i disponibili ({availableCount})</Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
